import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Router/LanguageContext";

export default function MissionSection({
  reverse = false,
  data,
  classAdd,
  reverseClass,
}) {
  const navigate = useNavigate();

  const redirect = (path) => {
    navigate(path);
  };
  const { dictionary } = useLanguage();

  return (
    <>
      <div
        className={`row ourSolutionSection ${
          reverse ? "flex-row-reverse" : ""
        }`}
      >
        <div className="col-md-6 position-relative">
          <div
            className={`mission-image-wrapper ${reverse ? "align-right" : "align-left"}`}
          >
            <motion.img
              src={data?.img1}
              className={`mission-img-main img-fluid ${
                !data?.img2 ? "missionMaxImg" : ""
              }`}
              initial={{ opacity: 0, x: reverse ? 60 : -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            />
            {data?.img2 && (
              <motion.img
                src={data?.img2}
                className={`mission-img-float ${
                  reverse
                    ? reverseClass
                      ? reverseClass
                      : "float-left"
                    : classAdd
                      ? classAdd
                      : "float-right"
                }`}
                initial={{ opacity: 0, scale: 0.85, y: "-50%" }}
                whileInView={{ opacity: 1, scale: 1, y: "-50%" }}
                whileHover={{ scale: 1.03 }}
                transition={{
                  opacity: { duration: 1, ease: "easeInOut" },
                  scale: { duration: 0.25, ease: "easeOut" },
                }}
                viewport={{ once: true }}
              />
            )}
          </div>
        </div>
        <div className="col-md-6 energysection missionSection">
          <motion.h2
            className="mission-title m-0 f-s-48"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {data?.title}
          </motion.h2>
          <motion.p
            className="mission-text m-0 f-s-18"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {data?.description}
          </motion.p>
          <ul className="mission-list">
            {data?.arrayData?.map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: reverse ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                viewport={{ once: true }}
              >
                <div className="energysectionpoints f-s-18">
                  <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                </div>
              </motion.li>
            ))}
          </ul>

          <div className="discovermoreBtn">
            <button
              className="radius-btn"
              onClick={() => redirect(data.routerPath)}
            >
              <span className="btn-text">{dictionary?.discoverMore}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
